<mf-page title="Editar orden de pago">
  @if (paymentOrderDto) {
  <mf-payment-order
    [paymentOrderDto]="paymentOrderDto"
    (close)="close()"
    (save)="save($event)" />
  }
</mf-page>
